import React, { FC, useRef, useState, useEffect, useMemo } from 'react';
import { VariableSizeList as List } from 'react-window';
import { ChartCard, ChartCardProps } from './ChartCard'; // Adjust the import path as necessary
import { useInView } from 'react-intersection-observer';
import Count from '../../components/charts/Count';
import Colors from '../utilities/Colors'; // Adjust the import path as necessary
import { useGlobalActiveCategory, useGlobalActiveSubCategory, onHoverHistogram, useGlobalHoveredId, useGlobalSelectedId, useGlobalActiveIndicator, 
  useGlobalBivariateIndicator, useGlobalActiveGeography, useCategoryChangeComplete, useGlobalModuleId, useGlobalRGModuleId, useGlobalActivePage, 
  onSetSTModuleId,
  useGlobalSTModuleId} from '../../data/StatusStore'; // Adjust the import path as necessary
import { onSetActiveIndicator, onSetBivariateIndicator, onSetActiveGeography, onSetSelectedId, onSetActiveSubCategory, onSetActiveCategory, onSetCategoryChangeComplete, onSetModuleId, onSetDBModuleId, onSetRGModuleId, onSetActiveSTModuleId } from '../../data/StatusStore';
import { onSetStoryFlyTo, onSetStoryFitBounds } from '../../data/GlobalStore';
//import { active, index } from 'd3';
import { debounce } from 'lodash';
import { useData } from '../../data/DataContext';
import { active } from 'd3';

interface DataItem {
  id: string;
  value: any;
}

interface ChartIndexProps {
  indicatorOptions: any;
  groupedModules: any;
  unGroupedModules: any;
  allData: any | null;
  chartId: string;
  handleChildReady: Function;
  moduleIdIncrement: number;
  updateDashboardModules: Function;
  validateCustomConfig: Function;
  unusedIndicatorsPerCategory?: any;
  setModuleIdIncrement: Function;
  setShowBackToStories: Function | null;
}

// New component to observe each ChartCard
const ObservedChartCard: FC<ChartCardProps & {   
    chartIndicator: any;
    chartIndicatorName: string;
    allData: any |null;
    chartId: string;
    height: string;
    width: string;
    index: number;
    options: any;
    activeGeography: string;
    colorCategory: string;
    updateDashboardModules: Function;
    validateCustomConfig: Function;
    setModuleIdIncrement: Function;
    moduleIdIncrement: number;
    //item: any;
    //onSetActiveIndicator: (indicator: string) => void;
    //onSetBivariateIndicator: (indicator: string) => void;
    //activeIndicator : string;
    //bivariateIndicator : string;
    _selectedId: string | null;
    style: React.CSSProperties;
    context: "stat explorer" | "data stories";
    unusedIndicatorsPerCategory?: any;
    setShowBackToStories: Function | null;
    //persistableSelectedId: string | null;
    }> = ({ setShowBackToStories, setModuleIdIncrement, moduleIdIncrement, context, index, options, chartId, /*item,*/ allData, activeGeography, _selectedId, style, colorCategory, updateDashboardModules, validateCustomConfig, ...props }) => {
  // Scroll Selection is managed by the ref that is created with useInView below and utilized in the return statement.
  // Uncomment these in order to re-engage this functionality. # scroll on div, scrolling selections, indicator selectornull);

  const { ref, inView, entry } = useInView({
    threshold: 0, // Number between 0 and 1 indicating the percentage that should be visible before triggering. Can also be an array of numbers, to create multiple trigger points.
    triggerOnce: false, // Ensure it triggers every time it comes into view
    //root: document.querySelector('#in-view-root'), //divRef.current || null,
    //rootMargin: '0px', // No margin around the root
    //rootMargin: "-50% 0px -50% 0px"
    root: document.querySelector('.list-container'),
    rootMargin: "-50% 0px -50% 0px",
  });

  const categoryChangeComplete = useCategoryChangeComplete();
  const selectedSubCategory = useGlobalActiveSubCategory();
  const selectedCategory = useGlobalActiveCategory();
  const moduleId = useGlobalModuleId();
  const RGModuleId = useGlobalRGModuleId();
  const STModuleId = useGlobalSTModuleId();
  const activePage = useGlobalActivePage();
  const selectedId = useGlobalSelectedId();
  
  const implementDirective = (directive: string) => {
    console.log("EE033125 Implementing directive:", directive);
    const directives = directive.split(','); // Split the directive on commas
    directives.forEach((dir) => {
      const [key, value] = dir.split('='); // Split each directive on '='
      console.log(`EE033125 Key: ${key.trim()}, Value: ${value.trim()}`); // Log the parsed key and value
      switch (key.trim()) {
        /*case "activeIndicator":
          onSetActiveIndicator(value.trim());
          break;
        case "bivariateIndicator":
          onSetBivariateIndicator(value.trim());
          break;*/
        case "activeIndicator":
          onSetActiveIndicator(value.trim(), "stories directive", null);
          break;
        case "bivariateIndicator":
          onSetBivariateIndicator(value.trim(), "stories directive", "");
          break;
        case "activeGeography":
          console.log("G042625 onSetActiveGeography(value.trim()", value.trim())
          // Never change geography via scroll directive while on the stories page.
          // Story charts only have data for the current geography; switching mid-scroll
          // causes a crash and resets back to story tab 1.
          if (activePage !== 'stories') {
            onSetActiveGeography(value.trim());
          }
          break;
        case "selectedId":
          console.log(`EE033125 Setting selectedId: ${value.trim()}`);
          console.log("A040525 value.trim()", value.trim());
          console.log("G0452625 setSelectedId(value.trim()", value.trim())
          // When on the stories page, skip selectedId dispatch only if the directive
          // specifies a DIFFERENT activeGeography than the current one. Setting a
          // cross-geo selectedId (e.g. a Tract ID while activeGeography=CD) would
          // corrupt cachedSelectedIds for the current geography, causing a crash when
          // Back to Stories restores that cached value.
          // Same-geo directives (e.g. activeGeography=CD while on CD) are allowed so
          // that scroll-driven selectedId changes (NYC story: selectedId=105, 206, etc.)
          // continue to work correctly.
          if (activePage === 'stories') {
            const geoMatch = directive.match(/activeGeography=([^,]+)/);
            if (geoMatch && geoMatch[1].trim() !== activeGeography) {
              break;
            }
          }
          onSetSelectedId(value.trim());
          break;
        /*case "activeSubCategory":
          onSetActiveSubCategory(value.trim());
          break;
        case "activeCategory":
          onSetActiveCategory(value.trim());
          break;
        case "moduleId":
          onSetModuleId(value.trim());
          break;
        case "dbModuleId":
          onSetDBModuleId(value.trim());
          break;*/
        case "flyTo":
          // Set selectedId first, then trigger storyFlyTo for zoom-in/out animation
          onSetSelectedId(value.trim());
          onSetStoryFlyTo({ geoid: value.trim(), ts: Date.now() });
          break;
        case "fitBounds":
          // Reset map view to full extent of all features
          onSetStoryFitBounds({ ts: Date.now() });
          break;
        default:
          console.warn(`Unknown directive key: ${key.trim()}`);
      }
    });
  };

  /*useEffect(() => {
    console.log("Z040525 inView, props.chartIndicator", inView, props.chartIndicator);
    //console.log("A040525 _selectedId", _selectedId);
    console.log("G042625 selectedId", selectedId);
    if (!selectedId && _selectedId !== null && activePage === 'rg'){
      console.log("Z040525 _selectedId", _selectedId);
      onSetSelectedId(_selectedId)
    }
  }, []);*/
  
  useEffect(() => {
    
    //console.log("G042625 inView, props.chartIndicator", inView, props.chartIndicator);
    //console.log("A040525 _selectedId", _selectedId);
    //console.log("G042625 selectedId", selectedId);
    //
    if (inView) {
      //console.log("E010626 inView, props.chartIndicator", inView, props.chartIndicator);
      console.log("B010726 options", options);
      if (!selectedId && _selectedId !== null && activePage === 'rg'){
        //console.log("A040525 _selectedId", _selectedId);
        onSetSelectedId(_selectedId)
      }
      // Do something when the ChartCard is in view
      //console.log('E033125 ChartCard in view: props', props);
      //console.log('E033125 ChartCard in view: options', options);
      //console.log('E033125 ChartCard moduleId', options.variables[0].sort.moduleId);
      const storiesDirective = options.variables.length > 1
        ? options.variables
            .map((variable: any) => variable.sort["Stories Directive"])
            .filter((directive: string | null) => directive && directive.trim() !== "")
            .join(",")
        : options.variables[0]?.sort["Stories Directive"] || "";
      if (storiesDirective){
        implementDirective(storiesDirective);
      }
      //console.log("EE033125 Stories Directive:", storiesDirective);
      //console.log("C101424 categoryChangeComplete", categoryChangeComplete);
      //console.log("DD101424 entry", entry);
      //console.log("DD101424 ref", ref);
      //console.log("H100424 selectedCategory", selectedCategory);
      //console.log("H100424 selectedSubCategory", selectedSubCategory);
      //console.log("H100424 options.category", options.category);
      //console.log("H100424 options.subCategory", options.subCategory);
      //console.log("A042625 activePage", activePage);
      //console.log("A042625 options.variables[0].sort.moduleId, moduleId", options.variables[0].sort.moduleId, moduleId);
      if ((options.variables[0].sort.moduleId !== moduleId) && (activePage === 'explorer')) {
        console.log("X122725 options.variables[0].sort.moduleId", options.variables[0].sort.moduleId);
        onSetModuleId(options.variables[0].sort.moduleId);
      }
      if ((options.variables[0].sort.moduleId !== STModuleId) && (activePage === 'stories')) {
        console.log("E010626 options.variables[0].sort.moduleId", options.variables[0].sort.moduleId);
        onSetSTModuleId(options.variables[0].sort.moduleId);
        // Only update globalActiveSTModuleId (which drives map/histogram color)
        // when this module carries an activeIndicator directive
        if (storiesDirective && storiesDirective.includes('activeIndicator')) {
          onSetActiveSTModuleId(options.variables[0].sort.moduleId);
        }
      }
      if ((options.variables[0].sort.moduleId !== RGModuleId) && (activePage === 'rg')) {
        //console.log("G042625 onSetRGModuleId(options.variables[0].sort.moduleId);", options.variables[0].sort.moduleId);
        onSetRGModuleId(options.variables[0].sort.moduleId);
      }
      if (options.category !== selectedCategory) {
        //console.log("A041125 onSetActiveCategory(options.category)", options.category);
        onSetCategoryChangeComplete(true);
        onSetActiveCategory(options.category);    
      }
      //console.log("A041125 options.subCategory !== selectedSubCategory", options.subCategory, selectedSubCategory);
      if (options.subCategory !== selectedSubCategory) {
        onSetCategoryChangeComplete(true);
        //console.log("A041125 onSetActiveSubCategory key", options.subCategory);
        onSetActiveSubCategory(options.subCategory);
      }
      if (options.subCategory === selectedSubCategory && options.category === selectedCategory) {
        //console.log("A041125 options.subCategory === selectedSubCategory && options.category === selectedCategory", options.category, options.subCategor, selectedCategory);
        onSetCategoryChangeComplete(false);
      }
      
      //console.log('072724 ChartCard in view: item', item);
      //console.log('072724 ChartCard in view:', props.chartIndicator);
      //if (onSetActiveIndicator) {
        //onSetActiveIndicator(props.chartIndicator);
      //}
    }else{
     // console.log('DD101424 ChartCard moduleId |__', options.variables[0].sort.moduleId);
    }
  }, [inView, props.chartIndicator]);
  //console.log("B111624 allData",allData);
  return (
    <div ref={ref} style={style}>
      <ChartCard 
          key={`chart-card-card${index}`}
          index={index}
          chartIndicator={options.variables}
          chartIndicatorName={options.breadcrumb}
          allData={allData}
          chartId={chartId}
          height={'200'}
          width={'75%'}
          //width={'calc(100% - 0px)'}
          activeGeography={activeGeography}
          updateDashboardModules={updateDashboardModules}
          validateCustomConfig={validateCustomConfig}
          setModuleIdIncrement={setModuleIdIncrement}
          moduleIdIncrement={moduleIdIncrement}
          /*onSetActiveIndicator={onSetActiveIndicator}
          onSetBivariateIndicator={onSetBivariateIndicator}
          activeIndicator={activeIndicator}
          bivariateIndicator={bivariateIndicator}*/
          options={options}
          _selectedId={_selectedId}
          context={context}
          column={1}
          unGroupedModules={props.unGroupedModules}
          groupedModules={props.groupedModules}
          unusedIndicatorsPerCategory={props.unusedIndicatorsPerCategory}
          setShowBackToStories={setShowBackToStories}
          //persistableSelectedId={persistableSelectedId}
      />
    </div>
  );
}; 

interface NestedJson {
  [category: string]: {
    [subCategory: string]: {
      [module: string]: {
        [group: string]: {
          [shape: string]: any[];
        };
      };
    };
  };
}

const ChartList: FC<ChartIndexProps> = ({
  setShowBackToStories, setModuleIdIncrement, unGroupedModules, indicatorOptions, groupedModules, allData, chartId, handleChildReady, moduleIdIncrement, updateDashboardModules, validateCustomConfig
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerHeight, setContainerHeight] = useState(0);
  const [persistableSelectedId, setPersistableSelectedId] = useState<string | null>(null);
  //const [previousCategory, setPreviousCategory] = useState<string | null>("");
  const [flattenedModules, setFlattenedModules] = useState<any | null>(null);
  const [heightsModules, setHeightsModules] = useState<any | null>(null);
  const [unusedIndicatorsPerCategory, setUnusedIndicatorsPerCategory] = useState<any | null>(null);
  const [flattenedModulesKey, setFlattenedModulesKey] = useState(0);
  const [listKey, setListKey] = useState(0);
  const listRef = useRef<List>(null);
  const isScrollingRef = useRef(false);
  const [scrollOffset, setScrollOffset] = useState(0);
  const [scrollIndex, setScrollIndex] = useState(0);

  const activeIndicator = useGlobalActiveIndicator();
  const bivariateIndicator = useGlobalBivariateIndicator();
  const activeGeography = useGlobalActiveGeography();
  const selectedId = useGlobalSelectedId();
  const selectedSubCategory = useGlobalActiveSubCategory();
  const selectedCategory = useGlobalActiveCategory();
  const categoryChangeComplete = useCategoryChangeComplete();
  const moduleId = useGlobalModuleId();
  const RGModuleId = useGlobalRGModuleId();
  const STModuleId = useGlobalSTModuleId();
  const activePage = useGlobalActivePage();
 const { dataPoint, isLoadingPoint, setDataPoint, dataSorter, dataSorterOrder, pointModules, pointMeta, geoJsonDataPUMA, geoJsonDataTract, geoJsonDataNTA, geoJsonDataBoro, isLoadingTopology, error } = useData();
  useEffect(() => {

    //onSetSelectedId("36061000900");
    console.log("E010626 indicatorOptions, groupedModules, allData, chartId",indicatorOptions, groupedModules, allData, chartId);

    if (containerRef.current) {
      setContainerHeight(containerRef.current.clientHeight - (activePage == 'rg' ? 0 : 81));
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerHeight(containerRef.current.clientHeight - (activePage == 'rg' ? 0 : 81));
      }
    };
    //console.log("101124 calling  handleChildReady ");
    handleChildReady();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    // Notify parent when ready
    
  }, []);
  
  useEffect(() => {
    //console.log("K032925 dataPoint", dataPoint);
    /*const firstCountItemIndex = flattenedModules.findIndex((item: any) => item.type === 'count');
    if (flattenedModules[firstCountItemIndex]) { // Render all count items
      return renderRow({ index: firstCountItemIndex, style: {} });
    }*/
  }, [dataPoint]);
  
  useEffect(() => {
    console.log("E010626 heightsModules", heightsModules);
    if (setModuleIdIncrement){
        const debounceSetModuleIdIncrement = debounce(() => {
            setModuleIdIncrement((prev: number) => prev + 1);
        }, 3);
        debounceSetModuleIdIncrement();
    }
  }, [heightsModules]);
  
  /*useEffect(() => {
    console.log("A100424 activeGeography",activeGeography);
  }, [activeGeography]);
  useEffect(() => {
    console.log("C102024 |______ moduleId",moduleId);
  }, [moduleId]);
  useEffect(() => {
    console.log("C102024 |______ moduleIdIncrement",moduleIdIncrement);
  }, [moduleIdIncrement]);
  useEffect(() => {
    //console.log("C101424 scrollOffset",scrollOffset);
    //console.log("C101424 heightsModules",heightsModules);
  }, [scrollOffset]);*/

  useEffect(() => {
    //if (!flattenedModules || flattenedModules.length < 0) {
      //console.log("A100424 groupedModules",groupedModules);
      //console.log("A062024 selectedCategory",selectedCategory);
      //console.log("A062024 selectedSubCategory",selectedSubCategory);
      /*let filteredModules = {
        [selectedCategory]: {
          [selectedSubCategory]: groupedModules[selectedCategory][selectedSubCategory],
        },
      };*/
      let filteredModules = {...groupedModules};
      //console.log("X102724 filteredModules",filteredModules);
      //console.log("B121125 groupedModules",groupedModules);
      //console.log("X102724 groupedData",groupedData);
      const result = flattenNestedJson({ ...groupedModules });
      console.log("122725 result",result);
      //console.log("D082924 indicatorOptions",indicatorOptions);
      if (result){
        setUnusedIndicatorsPerCategory(result[2]);
        setFlattenedModules(result[0].length !== 0 ? result[0] : flattenedModules ? flattenedModules : []);
        setHeightsModules(Object.keys(result[1]).length !== 0 ? result[1] : heightsModules ? heightsModules : {});
      }
    //}
  }, [groupedModules, /* selectedCategory, selectedSubCategory*/ ]);

  useEffect(() => {
    //console.log("A062024 groupedModules",groupedModules);
    //console.log("A062024 selectedCategory",selectedCategory);
    //console.log("A062024 selectedSubCategory",selectedSubCategory);
    setFlattenedModulesKey(prevKey => prevKey + 1)
    setListKey(prevKey => prevKey + 1);
  }, [groupedModules/*, selectedCategory, selectedSubCategory*/ ]);

  /*
  useEffect(() => {
    console.log("C082924 groupedModules",groupedModules);
  }, [groupedModules]);
  useEffect(() => {
    console.log("C082924 activeGeography",activeGeography);
  }, [activeGeography]);
  */
  useEffect(() => {
    console.log("JJ032925 flattenedModules", flattenedModules);
    /*if (flattenedModules) {
      const firstCountItem = flattenedModules.find((item: any) => item.type === 'count');
      console.log("JJ032925 firstCountItem", firstCountItem);
      Count({
        //key: `list_DUMMY`,
        options: firstCountItem,
        data: allData[activeGeography],
        width: 700,
        height: 180,
        colorClass: firstCountItem.variables[0].sort.Sort.Color,
      });
    }*/
    setListKey(prevKey => prevKey + 1); // Update the key to force re-render
  }, [flattenedModules, flattenedModulesKey]);
  /*
  useEffect(() => {
    console.log("C082924 listKey",listKey);
  }, [listKey]);
  */
  useEffect(() => {
    console.log("100424 selectedId",selectedId);
    //handleChildReady();
    //console.log("060524 <--- selectedId",selectedId);
    //console.log("060524 <--- persistableSelectedId",persistableSelectedId);
    //console.log("060524 <--- activeGeography",activeGeography);
    if (selectedId) {
      setPersistableSelectedId(selectedId);
    }  
  }, [selectedId]);

  function reorderByOrder(data: any): any {
    // Extract first-level keys
    const firstLevelKeys = Object.keys(data);
  
    // Sort the first-level keys based on the Order value found in their nested arrays
    const sortedFirstLevelKeys = firstLevelKeys.sort((a, b) => {
      //console.log("JJJ102624 a",a);
      //console.log("JJJ102624 b",b);
      //console.log("JJJ102624 data",data);
      const orderA = getDeepOrderValue(data[a]);
      const orderB = getDeepOrderValue(data[b]);
      //console.log("JJJ102624 orderA",orderA);
      //console.log("JJJ102624 orderB",orderB);
      return orderA - orderB;
    });
    //console.log("JJ102624 sortedFirstLevelKeys",sortedFirstLevelKeys);
    // Create a new object with sorted first-level keys
    const sortedData: any = {};
    sortedFirstLevelKeys.forEach((key) => {
      if (data[key]){
        sortedData[key] = reorderSecondLevel(data[key]);
      }
    });
  
    return sortedData;
  }
  
  // Helper function to reorder the second-level keys within each first-level key
  function reorderSecondLevel(obj: any): any {
    //console.log("D082924 obj",obj);
    const secondLevelKeys = Object.keys(obj);
  
    const sortedSecondLevelKeys = secondLevelKeys.sort((a, b) => {
      const orderA = getDeepOrderValue(obj[a]);
      const orderB = getDeepOrderValue(obj[b]);
      return orderA - orderB;
    });
    //console.log("J102624 sortedSecondLevelKeys",sortedSecondLevelKeys);
    const sortedSecondLevelData: any = {};
    sortedSecondLevelKeys.forEach((key) => {
      sortedSecondLevelData[key] = obj[key];
    });
  
    return sortedSecondLevelData;
  }
  
  // Helper function to find the Order value deep within the structure
  function getDeepOrderValue(obj: any): number {
    // Traverse the third-level keys to find the first array and get the Order
    for (const key in obj) {
      if (Array.isArray(obj[key]) && obj[key].length > 0) {
        let ret = obj[key][0]?.Order ?? 0; // Return the Order value, default to 0 if not found
        //console.log("JJ102624 obj",obj);
        //console.log("JJ102624 key,ret",key,ret);
        return ret; 
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        return getDeepOrderValue(obj[key]); // Recursively look deeper in the object
      }
    }
    return 0; // Default to 0 if no array with Order is found
  }
  
  // Example usage
  const jsonData = {
    "Age at a glance": {
      "Ungrouped": {
        "deviation from average": [
          { VARIABLE_NAME: 'sixtyfive', DISPLAY_NAME: 'Elderly (65+)', Order: 2 },
          // other items...
        ],
      },
    },
    "Birthplace": {
      "pie_birthplace": [
        { VARIABLE_NAME: 'native', DISPLAY_NAME: 'Native Born', Order: 1 },
      ],
    },
    // Other first-level and second-level keys...
  };
  
  //const sortedData = reorderByOrder(jsonData);
  //console.log(sortedData);
  function cleanString(input: string): string {
    let returnable = input
      .toLowerCase() // Convert to lowercase
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, ''); // Remove all non-web-safe characters except hyphens
    console.log("C102724 cleanString", input,">", returnable);
    return returnable;
  }
  
  const flattenNestedJson = (nestedJson: NestedJson): any => {
    const flatArray: any = [];
    const heightsArray: any = {};
    const missingIndicatorsPerCategory: any = {};
    let runningHeight = 0;
    let runningIndex = 0;
    //console.log("Z102724 nestedJson",nestedJson);
    Object.keys(nestedJson).forEach(category => {
      //console.log("B102824 category", category);
      /*const __object = {
        allDataPresent: true, //allDataPresent,
        variables: [], //transformedDataArray,
        type: "category header", //transformedDataArray[0].type,
        breadcrumb: `${category}`, 
        category: category,
        subCategory: Object.keys(nestedJson[category])[0],
      } 
      //console.log("D082924 getItemSizeWithObject(_object)",getItemSizeWithObject(_object));
      runningHeight = runningHeight + getItemSizeWithObject(__object);
      
      heightsArray[`${cleanString(category)}-header`] = ({
        runningHeight: runningHeight,
        runningIndex: runningIndex,
        moduleId: `${cleanString(category)}-header`,
        breadcrumb: __object.breadcrumb,
        type: __object.type,
      });
      runningIndex = runningIndex + 1;
      flatArray.push(__object);*/
      const subCategories = nestedJson[category];
      //console.log("YYY102724 subCategories", subCategories);
      Object.keys(subCategories).forEach(subCategory => {
        const modules = reorderByOrder(subCategories[subCategory]);
        //console.log("YYY102724 subCategory", subCategory);
        //if (subCategory === "American Human Development Index"){
        //  console.log("YYY102724 modules", modules);
        //}
        Object.keys(modules).forEach(module => {
          const groups = modules[module];
          //console.log("YY102724 module", module);
          //console.log("YY102724 groups", groups);
          //let groups_ = reorderByOrder(groups);
          //console.log("100924 groups_", groups_);
          Object.keys(groups).forEach(group => {
            //console.log("YY102724 group", group);
            if (group !== "order"){
              const shapes = groups[group];
              //console.log("YY102724 shapes",shapes);
              Object.keys(shapes).forEach(shape => {
                //console.log("100924 shapes", shapes);
                const dataArray = shapes[shape];
                //console.log("X102724 dataArray",dataArray);
                //console.log("X102724 shape",shape);
                //console.log("072724 activeGeography",activeGeography);
                //console.log("072724 activeGeography.toUpperCase()",activeGeography.toUpperCase());
                let allDataPresent = true;
                
                const transformedDataArray: any = dataArray.map((data: any, index: number) => {
                  //console.log("C100424 data",data);
                  //console.log("C100424 activeGeography",activeGeography);
                  //console.log("C100424 activeGeography.toUpperCase()",activeGeography.toUpperCase());
                  //console.log("C100424 data[activeGeography.toUpperCase()] ",data[activeGeography.toUpperCase()] );
                  //console.log("C100424 data[activeGeography] ",data[activeGeography] );
                  if (data[activeGeography] !== "X" && data["POINT"] !== "Yes") {
                    allDataPresent = false;
                    if (activeGeography == "CD"){
                      if (data["PUMA"] !== "X") {
                        allDataPresent = false;
                      }else{
                        allDataPresent = true;
                      }
                    }
                  }
                  return ({
                    label: data.DISPLAY_NAME,
                    variable: data.VARIABLE_NAME ? data.VARIABLE_NAME : data.variable,
                    type: data.Shape ? data.Shape : "beeswarm",
                    sort: data,
                    index: index,
                    geo: activeGeography,
                    category: category,
                  })
                });
                if (!allDataPresent){
                  //console.log("D121025 category",category);
                  //console.log("D121025 dataArray",dataArray);
                  if (!missingIndicatorsPerCategory[category]){
                    missingIndicatorsPerCategory[category] = [];
                  }
                  missingIndicatorsPerCategory[category].push(dataArray);
                }
                //if (allDataPresent){
                //console.log("100924 transformedDataArray",transformedDataArray);
                  const _object = {
                    allDataPresent: allDataPresent,
                    variables: transformedDataArray,
                    type: transformedDataArray[0].type,
                    breadcrumb: `${category} > ${subCategory} > ${module} > ${group} > ${shape}`, 
                    category: category,
                    subCategory: subCategory,
                  } 
                  console.log("A012326 getItemSizeWithObject(_object)",getItemSizeWithObject(_object));
                  runningHeight = runningHeight + getItemSizeWithObject(_object);
                  
                  heightsArray[transformedDataArray[0].sort.moduleId] = ({
                    runningHeight: runningHeight,
                    runningIndex: runningIndex,
                    moduleId: transformedDataArray[0].sort.moduleId,
                    breadcrumb: _object.breadcrumb,
                    type: _object.type,
                  });
                  runningIndex = runningIndex + 1;
                  flatArray.push(_object);
                //}
              });
            }
          });
        });
      });
    });
    console.log("YY102724 flatArray", flatArray);
    console.log("YY102724 heightsArray", heightsArray);
    console.log("C121125 missingIndicatorsPerCategory", missingIndicatorsPerCategory);
    return [flatArray, heightsArray, missingIndicatorsPerCategory];
  };

  /*const updateSelectedId = debounce((index: number) => {
    if (flattenedModules && flattenedModules[index]) {
      const item = flattenedModules[index];
      console.log("A060224 item",item);
      console.log("060524 ---> selectedId",selectedId);
      console.log("060524 ---> persistableSelectedId",persistableSelectedId);
      if (item && item.variables && item.variables[0]) {
        if (selectedId){
          console.log("EEE112724 ||||||------------> onSetSelectedId selectedId",selectedId);
          onSetSelectedId(selectedId);
        }else{
          if (persistableSelectedId){
            console.log("EEE112724 ||||||------------> onSetSelectedId persistableSelectedId",persistableSelectedId);
            onSetSelectedId(persistableSelectedId);
          }
        }
      }
    }
  }, 300); // Debounce interval set to 300ms*/

  const scrollToCategory = () => {
    console.log("X122725 scrollToCategory selectedCategory",selectedCategory);
    //console.log("A041125 selectedCategory",selectedCategory);
    //console.log("A041125 selectedSubCategory",selectedSubCategory);
    //console.log("A041125 flattenedModules",flattenedModules);
    if (flattenedModules) {
      const index = flattenedModules.findIndex(
        (item: any) => item.category === selectedCategory && item.subCategory === selectedSubCategory
      );
      if (index >= 0 && listRef.current) {
        isScrollingRef.current = true;
        listRef.current.scrollToItem(index, 'start');
        //setTimeout(() => {
        isScrollingRef.current = false;
        //console.log("072824 onSetCategoryChangeComplete(false);");
        onSetCategoryChangeComplete(false);
        //}, 500); // Allow some time for the scroll to complete
      }else{
        //console.log("072824 onSetCategoryChangeComplete(false);");
        onSetCategoryChangeComplete(false);
      }
    }
  };

  useEffect(() => {
    //console.log("A041125 selectedCategory",selectedCategory);
    //console.log("A041125 selectedSubCategory",selectedSubCategory);
    //console.log("A041125 categoryChangeComplete", categoryChangeComplete);
    //console.log("A041125 isScrollingRef.current",isScrollingRef.current);
    if (!isScrollingRef.current && !categoryChangeComplete) {
      scrollToCategory();
    }else{
      //console.log("C032925 onSetCategoryChangeComplete(false);");
      onSetCategoryChangeComplete(false);
    }
  }, [selectedCategory, selectedSubCategory]);

  const renderRow = useMemo(() => {
    //console.log("C100424 indicatorOptions",indicatorOptions)
    //console.log("B102824 flattenedModules",flattenedModules)
    //console.log("A041524 allData",allData)
    //console.log("C100424 activeGeography",activeGeography)
   
    return ({ index, style }: { index: number; style: React.CSSProperties }) => {
      const item = flattenedModules[index];
      //console.log("N092924 item",item)
      if (!item.allDataPresent) {
        //console.log("D121025 item.allDataPresent, item",item.allDataPresent,item)
        return null;
      }
      //console.log("E102824 item.categoryy",item.category)
      //console.log("E102824 previousCategory",previousCategory)
      //console.log("B111624 allData", allData);
      //console.log("B031125 style", style);
      //setPreviousCategory(item.category);
      //style.width = "70%";
      //style.left = "30%";
      return (
          <ObservedChartCard  /* ChartCard */
            key={`chart-card-${index}`}
            index={index}
            chartIndicator={item.variables}
            chartIndicatorName={item.breadcrumb}
            allData={allData}
            chartId={chartId}
            height={'200'}
            width={'calc(100% - 0px)'}
            activeGeography={activeGeography}
            colorCategory={item.category}
            updateDashboardModules={updateDashboardModules}
            validateCustomConfig={validateCustomConfig}
            /*onSetActiveIndicator={onSetActiveIndicator}
            onSetBivariateIndicator={onSetBivariateIndicator}
            activeIndicator={activeIndicator}
            bivariateIndicator={bivariateIndicator}*/
            setModuleIdIncrement={setModuleIdIncrement}
            moduleIdIncrement={moduleIdIncrement}
            options={item}
            _selectedId={selectedId}
            //item={item}
            style={style}
            context={(activePage === 'explorer' || activePage === 'rg') ? 'stat explorer' : 'data stories'}
            column={1}
            //persistableSelectedId={persistableSelectedId}
            unGroupedModules={unGroupedModules}
            groupedModules={groupedModules}
            unusedIndicatorsPerCategory={unusedIndicatorsPerCategory}
             setShowBackToStories={setShowBackToStories}
          />
      );
    };
  }, [flattenedModules, allData, chartId, listKey /*activeGeography, selectedId*/]);

  const handleScroll = debounce((scrollOffset: number, scrollDirection:string, scrollUpdateWasRequested:boolean) => {
    setScrollOffset(scrollOffset); // Save the current scroll offset
    //console.log("BB101424 scrollOffset",scrollOffset);
    //console.log("BB101424 scrollDirection",scrollDirection);
    //console.log("BB101424 scrollUpdateWasRequested",scrollUpdateWasRequested);
    //console.log("B101424 scrollOffset",scrollOffset);
    //console.log("BB101424 heightsModules",heightsModules);
    /*const filtered = Object.keys(heightsModules).find(key => {
      const h = heightsModules[key];
      return h.runningHeight > scrollOffset;
    });
    console.log("BB101424 filtered",filtered);
    console.log("BB101424 filtered",heightsModules[filtered ? filtered : moduleId]);*/
    /*if (filtered){
      setScrollIndex(filtered?.runningIndex);
    } */   
    //console.log("E082924 (old) selectedId",selectedId);
    //const itemIndex = Math.floor(scrollOffset / 200); // Calculate item index based on scroll offset and item height
    //console.log("E082924 (new) selectedId itemIndex",itemIndex);
    //updateSelectedId(itemIndex); // fallback logic based on a stanndard height of 200px
    
  }, 30); // Debounce interval set to 300ms

  const getItemSize = (index:number) => {
    //console.log("C082924 index",index);
    //console.log("C082924 flattenedModules[index]",flattenedModules[index]);
    //console.log("A061224 flattenedModules[index].type",flattenedModules[index].type);
    const _object = flattenedModules[index];
    console.log("A012326 ----> getItemSizeWithObject(_object)",getItemSizeWithObject(_object));
    return getItemSizeWithObject(_object);
  }

  const getItemSizeWithObject = (_object:any) => {
    if (!_object.allDataPresent) {
      return 0;
    }
    let defaultHeight = 250; //300;
    let defaultBarHeight = 200; //300;
    let space = 25;
    let additional = 31 + space; //300;
    //console.log("A083024 _object",_object);
    switch (_object.type.toLowerCase()) {
      case 'category header':
        let ret = 60 + space;
        return ret;
      case 'category footer':
        // Build unique list and count of unused indicators for this category
        let _defaultHeight = 5;
        const unused = unusedIndicatorsPerCategory?.[_object.category] || [];
        if (!unused || unused.length === 0) {
          console.log("A122825 0",0);
          //return 0;
        }
        const allItems = (Array.isArray(unused) ? unused.flat() : []).filter(Boolean);
        const seen = new Set<string>();
        const uniqueItems = allItems.filter((it: any) => {
          if (it?.["COMING SOON?"] === "Yes") return false;
          const name = it?.VARIABLE_NAME;
          if (!name) return false;
          if (seen.has(name)) return false;
          seen.add(name);
          return true;
        });

        // Two-column grid: 40px per two unique items (≈20px per item)
        const baseRows = Math.ceil(uniqueItems.length / 2);

        // Tract tends to wrap more text; inflate rows slightly based on avg label length
        const avgLen = uniqueItems.length
          ? uniqueItems
              .map((it: any) => String(it?.DISPLAY_NAME || '').split('(')[0].trim().length)
              .reduce((a: number, b: number) => a + b, 0) / uniqueItems.length
          : 0;
        let wrapFactor = 1;
        if (activeGeography === 'Tract') {
          if (avgLen > 60) wrapFactor = 1.35;
          else if (avgLen > 45) wrapFactor = 1.2;
        }
        const rows = Math.ceil(baseRows * wrapFactor);

        const computed = (rows * 40) + additional;
        console.log("A122825 Math.max(computed, defaultHeight);",Math.max(computed, _defaultHeight));
        //return Math.max(computed, _defaultHeight);
        //return 200;
        return activeGeography === "CD" ? 0 : 200;
      case 'histogram':
        return defaultHeight + additional;
      case 'beeswarm':
      case 'range beeswarm':
        const _filteredDataBS = _object.variables.filter((v: any) => !v.sort.Tooltip_only);
        let accumulatedNoteHeight = 0;
        let accumulatedSourceHeight = 0;
        let lh = 12.5;
        _filteredDataBS.forEach((v: any) => {
          const noteLength = (v.sort.NOTES ? v.sort.NOTES.length : 1);
          const sourceLength = (v.sort.SOURCE_NAME ? v.sort.SOURCE_NAME.length : 1);
          accumulatedNoteHeight += Math.ceil((noteLength / 40) * lh); // Adjust the multiplier as needed
          accumulatedSourceHeight += Math.ceil((sourceLength / 40) * 10); // Adjust the multiplier as needed
        });
        accumulatedNoteHeight = accumulatedNoteHeight < (lh * 3.5) ? lh * 3.5 : accumulatedNoteHeight;
        accumulatedSourceHeight = accumulatedSourceHeight < (lh * 2.5) ? lh * 2.5 : accumulatedSourceHeight;
        //return accumulatedHeight + 100 + additional;
        return (_filteredDataBS.length * 80) + accumulatedNoteHeight + accumulatedSourceHeight + additional;
        //return (_filteredDataBS.length * 100) + 100 + additional;
      case 'pie':
        return defaultHeight + additional;
      case 'waffle':
        return defaultHeight + additional;
      //case 'list':
      //  return defaultHeight + additional;
      case 'ranked list':
        return defaultHeight + additional;
      case 'pyramid':
        const _filteredDataP = _object.variables.filter((v: any) => !v.sort.Tooltip_only);
        return ((_filteredDataP.length / 1.35) * 25) + 10 + additional; // defaultHeight;
      case 'stacked histograms':
        const _filteredDataSH = _object.variables.filter((v: any) => !v.sort.Tooltip_only);
        return (_filteredDataSH.length * 115) + 100 + additional; // defaultHeight;
      case 'stacked swarms':
        const _filteredDataSS = _object.variables.filter((v: any) => !v.sort.Tooltip_only);
        return (_filteredDataSS.length * 100) + 100 + additional; // defaultHeight;
      case 'map':
        return 250; // defaultHeight;
      case 'deviation from average':
        const _filteredDataDEV = _object.variables.filter((v: any) => !v.sort.Tooltip_only);
        return (_filteredDataDEV.length * 40) + 70 + additional;
      case 'count':
        console.log("B041725 _object",_object);
        if (_object.variables[0].label === "not used"){ // THis is a hack to engage the count module first thing in the lazy load list and is needed to make sure that points and point toggle are properly engaged when the view is set to the first (real) instance of a count module. 
          return 0;
        }
        const uniqueDisplayNames = new Set();
        const _countVars = _object.variables.filter((v: any) => {
          if (!v.sort.Tooltip_only && !uniqueDisplayNames.has(v.sort.DISPLAY_NAME)) {
            uniqueDisplayNames.add(v.sort.DISPLAY_NAME);
            return true;
          }
          return false;
        });
        let ht = (_countVars.length * 30) + 70 + additional
        return ht < 400 ? 400 : ht;
      case 'cot':
        return 400 + additional;
      case 'wide blurb':
        const blurbContent = _object.variables[0]?.sort?.["Stories Content"] || "";
        const blurbLen = blurbContent.length;
        // Scale height with content: ~50 chars/line at ~20px/line, min 200px
        const blurbHeight = Math.max(200, Math.ceil(blurbLen / 45) * 18 + 80);
        return blurbHeight;
      case 'image':
        return 600;
      case 'image blurb':
        return 750;
      case 'iframe blurb':
        return 850;
      case 'image histogram':
        return 800;
      case 'bar':
        const _filteredData = _object.variables.filter((v: any) => !v.sort.Tooltip_only);
        return ((_filteredData.length * 27.5) + 70) < defaultBarHeight ? defaultBarHeight : ((_filteredData.length * 27.5) + 70) + additional;
      default:
        return defaultHeight + additional;
    }
  }
  useEffect(() => {
      console.log("C101424 activeGeography",activeGeography);
      console.log("C101424 flattenedModules",flattenedModules);
      console.log("C101424 |________________ moduleId",moduleId);
      if (listRef.current) {
          //setScrollOffset(listRef.current.state.scrollOffset); // Save the current scroll offset
      }
      
  }, [activeGeography, flattenedModules]); // Run this effect when the key dependencies change

  useEffect(() => {
    console.log("X122725 |________________ moduleId", moduleId);
    console.log("E010626 |________________ STModuleId", STModuleId);
    console.log("X122725 |________________ moduleIdIncrement", moduleIdIncrement);
    
    // Calculate the new scroll offset based on the moduleId
    console.log("E010626 |________________ heightsModules", heightsModules);
    let newScrollOffset = computeScrollOffset();

    console.log("E010626 |________________ newScrollOffset", newScrollOffset);
    // If the List component is mounted and the new scroll offset is calculated, scroll to the new position
    if (listRef.current) {
        listRef.current.scrollTo(newScrollOffset);
    }
  }, [moduleIdIncrement]); // Depend on moduleIdIncrement to trigger this effect
  //useEffect(() => {
    //console.log("Z102024 |________________ moduleId", moduleId);
    //console.log("Z102024 |________________ moduleIdIncrement", moduleIdIncrement);
    
  //}, [moduleId]); // Depend on moduleIdIncrement to trigger this effect
  const computeScrollOffset = () => {
    let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    let __moduleIdToUse = activePage === "explorer" 
      ? moduleId 
      : activePage === "rg" 
        ? RGModuleId 
        : STModuleId;
    console.log("E010626 |________________ __moduleIdToUse", __moduleIdToUse);
    console.log("E010626 |________________ heightsModules", heightsModules);
    let newScrollOffset = heightsModules && heightsModules[__moduleIdToUse]
        ? heightsModules[__moduleIdToUse].runningHeight - (vh / (activePage === "stories" ? 1.25 : 2))
        : 0;
    return newScrollOffset;
    /*return (activePage === "rg"
      ? 0
      : heightsModules 
        ? heightsModules[activePage === "explorer" ? moduleId : RGModuleId] 
          ? heightsModules[activePage === "explorer" ? moduleId : RGModuleId].runningHeight - (vh / 2)
          : 0
        : 0);*/
  }

  /*useEffect(() => {
      if (listRef.current) {
        console.log("A100524 scrollOffset",scrollOffset);
        let _scrollOffset = scrollOffset;
        if (scrollIndex && scrollOffset && heightsModules){
          console.log("A100524 scrollIndex",scrollIndex);
          console.log("A100524 heightsModules",heightsModules);
          console.log("A100524 heightsModules[scrollIndex]",heightsModules[scrollIndex]);
          _scrollOffset = heightsModules[scrollIndex].runningHeight;
        }
        listRef.current.scrollTo(_scrollOffset); // Restore the saved scroll offset
      }
  }, [listKey]);*/ // Restore scroll after re-render based on the new listKey
  
  //console.log("H042625 moduleId",moduleId);
  //console.log("H042625 RGModuleId",RGModuleId);
  //if (heightsModules){
  //  console.log("H042625 heightsModules",heightsModules);
  //  console.log("H042625 heightsModules[moduleId]",heightsModules[moduleId]);
  //  console.log("H042625 heightsModules[RGModuleId]",heightsModules[RGModuleId]);
  //  console.log("H042625 heightsModules[activePage === 'explorer' ? moduleId : RGModuleId].runningHeight - (vh / 2)",heightsModules[activePage === "explorer" ? moduleId : RGModuleId].runningHeight - (vh / 2));
  //}
  return (
    <div ref={containerRef} style={{ height: '100%' }}>
      <List
      className='list-container'
      key={`list_${listKey}`} // Adding a key to force re-render when flattenedModules changes
      height={containerHeight + (activePage === 'stories' ? 46 : 0)}
      width="100%"
      itemCount={flattenedModules ? flattenedModules.length : 0}
      itemSize={getItemSize} // The height of each row in pixels
      style={{ overflowX: 'hidden' }}
      onScroll={({ scrollOffset, scrollDirection, scrollUpdateWasRequested }) => handleScroll(scrollOffset, scrollDirection, scrollUpdateWasRequested)}
      ref={listRef}
      initialScrollOffset={
          computeScrollOffset()
      }
      >
      {renderRow}
      </List>
        {flattenedModules && flattenedModules.length > 0 && ( // this logic is so that count modules (point data) are loaded at all times, thus allowing their functiuonaliy to work
        <div style={{ display: 'none' }}>
          {
          (() => {
            const firstCountItemIndex = flattenedModules.findIndex((item: any) => item.type === 'count');
            /*if (firstCountItemIndex !== -1) { // Render the first count item
              return renderRow({ index: firstCountItemIndex, style: {} });
            }
            return null;*/
            if (flattenedModules[firstCountItemIndex]) { // Render all count items
              return renderRow({ index: firstCountItemIndex, style: {} });
            }
          })()
          }
        </div>
      )}
    </div>
  );
};

export default ChartList;
